import { gql } from '@apollo/client'

export default gql`
  fragment TargetBonusOfYear on TargetBonus {
    id
    amount
    fromDate
    toDate
    currency
    contractId
  }
`
